import Link from "next/link";
import * as React from "react";
import styles from "./styles.module.css";

const BroadbandDeals: React.FC = () => {
	return (
		<section className={styles.callout__section}>
			<div className="mt-5 mx-0 m-0  bg-primary-gradient d-flex flex-column justify-content-center align-items-center p-5 text-center">
				<h2 className="mt-0 mb-5 w-100 font-bold">
					Are you ready to see some amazing broadband deals?
				</h2>
				<Link
					className="button d-flex align-items-center w-25 text-decoration-none"
					href="/broadband"
				>
					Broadband Deals
				</Link>
			</div>
		</section>
	);
};

export default BroadbandDeals;
